import React from 'react';
import { TooltipProps as TooltipPropsMUI, Tooltip as TooltipMUI, tooltipClasses } from '@mui/material';
import styled from 'styled-components';

export type TooltipProps = {
    children?: JSX.Element | string
} & TooltipPropsMUI

const Tooltip = (props: TooltipProps): JSX.Element => <TooltipMUI {...props}>
    {props.children}
</TooltipMUI>;

export const SecondaryTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))`
    .${tooltipClasses.arrow}::before {
        background-color: #10334bf8;
        /* border: 1px solid #10334b7b; */
    }

    .${tooltipClasses.tooltip} {
        padding: 10px 15px;
        background: #10334bf8;
        color: white;
        box-shadow: 0 10px 36px 0 #eeeff1cc;
        /* border: 1px solid #10334b7b; */
    }

`;

export default Tooltip;
